import clsx from 'clsx';
import { useField } from 'formik';
import React from 'react';

import FieldError from './FieldError';
import FieldLabel from './FieldLabel';

const ExpiryField = ({ label, name, ...props }) => {
  const [field, meta, helpers] = useField(name);
  const { inputClassName, className } = props;

  const handleChange = (e) => {
    let raw = e.target.value.replace(/[^\d]/g, '');

    // Auto-prepend 0 to single digit month > 1 (e.g. '9' -> '09')
    if (raw.length === 1 && parseInt(raw, 10) > 1) {
      raw = '0' + raw;
    }

    // Extract month and year parts
    const month = raw.slice(0, 2);
    const year = raw.slice(2, 4);

    // Validate month
    if (month.length === 2) {
      const monthInt = parseInt(month, 10);
      if (monthInt < 1 || monthInt > 12) {
        return; // invalid month, ignore input
      }
    }

    let formatted = month;
    if (year.length) {
      formatted += '/' + year;
    }

    helpers.setValue(formatted);
  };

  const handleKeyDown = (e) => {
    // Handle deleting the slash character
    if (e.key === 'Backspace' && field.value.length === 3 && field.value.includes('/')) {
      e.preventDefault();
      helpers.setValue(field.value.slice(0, 2));
    }
  };

  return (
    <div className={className}>
      {label && (
        <FieldLabel htmlFor={name} className="text-label">
          {label}
        </FieldLabel>
      )}
      <input
        {...field}
        {...props}
        className={clsx(
          inputClassName,
          'h-[50px] w-full rounded-none border border-solid border-grayscale-beige px-8 py-16 font-suisse-intl text-overline-md text-primary-black placeholder-grayscale-gray focus:outline-none disabled:bg-white disabled:text-grayscale-gray disabled:opacity-40 dark:bg-[var(--light-grayscale-charcoal)]'
        )}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="MM/YY"
        maxLength={5}
        inputMode="numeric"
        pattern="\d{2}/\d{2}"
      />
      {meta.touched && meta.error && <FieldError>{meta.error}</FieldError>}
    </div>
  );
};

export default ExpiryField;
